import React, { useState } from "react";
import { Button, Form, Row } from "antd";
import ReactGA from "react-ga4";
import ModuleSearchGroups from "../ModuleSearchGroups/inde";
import QuickSearches from "../../QuickSearches/QuickSearches";
import styles from "./style.scss";
import { getIconUrl } from "../../../../services/asset";
import { submitFormData } from "../../../../HOCs";
import { saveSearch } from "../../../../routes/Search/search.ducks";
import SaveSearchForm from "../../../SearchPage/SaveSearchForm";

const ModuleSearchControls = props => {
  const {
    groups,
    form,
    onSubmit,
    numberOfControls,
    renderCategorySelector,
    showAllControls,
    closeAllSearch,
    resetFormFields,
    resetFields,
    categoryHr
  } = props;

  if (!groups || groups.length === 0) return null;

  const renderSearchBtn = onClick => {
    return (
      <Button
        type="primary"
        className={`uppercase ${styles.searchButton}`}
        onClick={onClick}
      >
        <img
          alt={"Traži"}
          src={getIconUrl("search-white.svg")}
        />
        {"Traži"}
      </Button>
    );
  };

  const handleResetFields = () => {
    const { form } = props;
    form.resetFields();
    resetFields();
    resetFormFields();
    ReactGA.event({
      category: "Pretraga",
      action: "Click",
      label: "Resetiranje filtera - naslovnica"
    });
  };

  return (
    <div>
      <div className={showAllControls ? styles.formWrapperAll : styles.formWrapper}>
        <Form>
          <Row type="flex" justify="center">
            <ModuleSearchGroups
              onSubmit={onSubmit}
              onReset={handleResetFields}
              form={form}
              groupConfigs={groups}
              numberOfControls={numberOfControls}
              renderCategorySelector={renderCategorySelector}
              showAllControls={showAllControls}
              closeAllSearch={closeAllSearch}
            />
          </Row>
        </Form>
        <div className={`${styles.quickSearchesWrapper} ${showAllControls ? styles.quickSearchesAll : ""}`}>
          <QuickSearches categoryHr={categoryHr} />
        </div>
      </div>
      {showAllControls && (
        <div className={styles.buttonsSection}>
          <div className={styles.actions}>
            <span onClick={handleResetFields} className={styles.imageWrapper}>
              <img
                alt={"Osvježi sada"}
                src={getIconUrl("reload.svg")}
              />
            </span>
            {renderSearchBtn(onSubmit)}
          </div>
        </div>
      )}
    </div>
  );
};

export default submitFormData(
  Form.create({
    // @ts-ignore
    onValuesChange: (props, _, allValues) => {
      const { onValuesChange } = props;
      onValuesChange(allValues);
    }
  })(ModuleSearchControls),
  saveSearch
);



// WEBPACK FOOTER //
// ./src/containers/ModulePage/ModuleSeaarchSection/ModuleSearchControls/index.tsx